export default function getResendEmailReducer
    (state = { error:null, success:null, processing:false }, action) {

    switch (action.type)
    {
        case 'GET_RESEND_EMAIL_SUCCESS':
            return {...state, ...{success: action.success }};

        case 'GET_RESEND_EMAIL_ERROR':
            return {...state, ...{ error: action.error }};

        case 'GET_RESEND_EMAIL_PROCESSING':
            return {...state, ...{ processing: action.processing }};

        default: return state;
    }
}